<template>
    <div class="animated fadeIn">
  
      <b-card class="card-accent-info">
        <div slot="header">
              Indicações
              <div class="card-header-actions">
                
                <b-link href="#" class="card-header-action btn-help">
                  <i class="icon-question" @click="openHelp('/?page=franchise/referral')"></i>
                </b-link>
                
                <!--
                <b-link href="#" class="card-header-action btn-helpvie">
                  <i class="icon-film"></i>
                </b-link>
                -->
              </div>
        </div>
        <b-card-body>
  
          <b-row>
            <b-col cols="auto" class="mr-auto">
             <!--
                <b-form-group>
                    <b-button variant="outline-primary" @click="myReferral">Indicação Interna</b-button>                
                </b-form-group>
              -->   
            </b-col>
            <b-col cols="auto" class="">
              <b-form-group>
                <!--
                <b-button variant="vine" class="mr-1 btn-brand" @click="enableDisable()"  v-show="tableSelectable"><i class="fa fa-toggle-on"></i><span>Alterar Status</span></b-button>
                &nbsp;
                -->
                <b-button variant="github" class="mr-1 btn-brand" @click="openEditModal(null)"><i class="fa fa-plus"></i><span>Nova Indicação</span></b-button>
              </b-form-group>
            </b-col>
          </b-row>
              
  
          <b-nav tabs>
            <b-nav-item :active="tabReferral=='A'" @click="changeTabReferral('A')" v-show="accessReferralManager">Gerenciar Indicações</b-nav-item>
            <b-nav-item :active="tabReferral=='E'" @click="changeTabReferral('E')">Indicações Recebidas</b-nav-item>
            <b-nav-item :active="tabReferral=='S'" @click="changeTabReferral('S')">Indicações Realizadas</b-nav-item>          
          </b-nav>

          <p></p>

          <b-row>
            <b-col cols="auto">
              <b-form-group>
                  <label for="company" style="font-size: 0.8em">Empresa</label>
                  <b-form-select id="company"
                    v-model="filters.companyId"
                    :plain="true"
                    :options="companyDDL"
                    @change="changeCompany"
                    :value="[null,'c']">
                  </b-form-select>
              </b-form-group>
            </b-col>

            <b-col cols="auto">
              <b-form-group>
                  <label for="group" style="font-size: 0.8em">Grupo</label>
                  <b-form-select id="group"
                    v-model="filters.groupId"
                    :plain="true"
                    :options="selectGroupDDL"
                    @change="refreshData"
                    :value="[null,'c']">
                  </b-form-select>
              </b-form-group>
            </b-col>

            <b-col cols="auto">
              <b-form-group>
                  <label for="name" style="font-size: 0.8em">Filtro</label>
                  <b-form-input v-model="filters.key" type="text" id="filter" placeholder="Filtro"></b-form-input>
              </b-form-group>
            </b-col>
      
            <b-col cols="auto">
              <b-form-group>
                  <label for="status" style="font-size: 0.8em">Associado Indicado</label>
                  <b-form-select id="status"
                    v-model="filters.emptyUserService"
                    :plain="true"
                    :options="emptyUserServiceDDL"
                    :value="[null,'c']">
                  </b-form-select>
              </b-form-group>
            </b-col>

            <b-col cols="auto">
              <b-form-group>
                  <label for="status" style="font-size: 0.8em">Status</label>
                  <b-form-select id="status"
                    v-model="filters.referralStatusId"
                    :plain="true"
                    :options="referralByGroupStatusDDL"
                    :value="[null,'c']">
                  </b-form-select>
              </b-form-group>
            </b-col>

            <b-col cols="auto" class="mr-auto" style="padding-top: 12px;">
              <b-form-group>
                <p></p>
                <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="refreshData()"><i class="fa fa-search"></i><span>Localizar</span></b-button>
              </b-form-group>
            </b-col>

            <b-col cols="auto" class="">
              <b-form-group >
                  <label for="perPage">Linhas</label>
                  <b-form-select v-model="perPage" id="perPage"
                    :plain="true"
                    :options="[5,10,20,50]">
                  </b-form-select>
                </b-form-group>
            </b-col>
            
          </b-row>
        
  
            <b-table
                :items="filteredItems"
                :fields="fields"
                :select-mode="selectMode"
                responsive="sm"
                ref="selectableTable"
                selectable
                @row-selected="onRowSelected"
                :primary-key="primaryKey"
                :tbody-transition-props="transProps"
                sort-icon-left
                @row-clicked="rowClicked"
                :per-page="perPage"
                :current-page="currentPage"
                :busy="isBusy"
                hover
                striped
  
                >
  
                <template #table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Carregando...</strong>
                    </div>
                </template>
                
                <!-- Example scoped slot for select state illustrative purposes -->
                <template #cell(selected)="{ rowSelected }">
                    <template v-if="rowSelected">
                    <span aria-hidden="true">&check;</span>
                    <span class="sr-only">Selected</span>
                    </template>
                    <template v-else>
                    <span aria-hidden="true">&nbsp;</span>
                    <span class="sr-only">Not selected</span>
                    </template>
                </template>
  
                <template #cell(show_details)="row">
                    <b-row>
                        <b-col cols="auto" class="mr-auto">
                            <b-form-group>
                            <b-button size="sm" variant="primary"  @click="row.toggleDetails" class="mr-1 btn-brand"><i class="fa fa-search"></i></b-button>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </template>
                
                <template #row-details="row">
                    <b-card>
                        <b-row v-show="row.item.summary && row.item.summary.length > 0">
                            <b-col class="small">Resumo</b-col>
                        </b-row>
                        <b-row>
                            <b-col class="text-primary">{{ row.item.summary }}</b-col>
                        </b-row>
                        <b-row v-show="row.item.content && row.item.content.length > 0">
                            <b-col class="small">Conteúdo</b-col>
                        </b-row>
                        <b-row>
                            <b-col class="text-primary">{{ row.item.content }}</b-col>
                        </b-row>
                        <b-row>
                            <b-col>{{ row.item.content }}</b-col>
                        </b-row>
                        <b-row>
                            <b-col><i>Publicado em <b>{{ row.item.publishedin }}</b> por <b>{{ row.item.publisher }}</b></i></b-col>
                        </b-row>
                    </b-card>
                </template>

                <template v-slot:cell(contact)="data">
                    <b>[{{ data.item.id }}] {{ data.item.serviceDescription }}</b><br>
                    <b-row>
                      <b-col sm="2"><small>Empresa:</small></b-col>
                      <b-col sm="4">{{ data.item.companyName }}</b-col>
                      <b-col sm="2"><small>Contato:</small></b-col>
                      <b-col sm="4">{{ data.item.contactName }}</b-col>
                    </b-row>
                    <b-row>
                      <b-col sm="2"><small>Telefone:</small></b-col>
                      <b-col sm="4">{{ data.item.contactPhone }}</b-col>
                      <b-col sm="2"><small>E-mail:</small></b-col>
                      <b-col sm="4">{{ data.item.contactEmail }}</b-col>
                    </b-row>
                    <b-row>
                      <b-col sm="2"><small>Indicado por: </small></b-col>
                      <b-col sm="4">{{ data.item.groupUser.user.name }}</b-col>
                      <b-col sm="2"><small>Indicado em: </small></b-col>
                      <b-col sm="4">{{ $utils.localDateShortTime(data.item.createdIn) }}</b-col>
                    </b-row>
                    <b-row v-if="(data.item.referralValue && data.item.referralValue > 0) || (data.item.monthlyValue && data.item.monthlyValue > 0)">
                      <b-col sm="2"><small>Indicação/inscrição: </small></b-col>
                      <b-col sm="4">{{ data.item.referralValue && data.item.referralValue > 0 ? $utils.numberFormat(data.item.referralValue) : '-' }}</b-col>
                      <b-col sm="2"><small>Mensalidade: </small></b-col>
                      <b-col sm="4">{{ data.item.monthlyValue && data.item.monthlyValue > 0 ? $utils.numberFormat(data.item.monthlyValue) : '-' }}</b-col>
                    </b-row>
                    <b-row v-if="(data.item.comissionValue && data.item.comissionValue > 0) || (data.item.monthlyComissionValue && data.item.monthlyComissionValue > 0)">
                      <b-col sm="2"><small>Comissão: </small></b-col>
                      <b-col sm="4">{{ data.item.comissionValue && data.item.comissionValue > 0 ? $utils.numberFormat(data.item.comissionValue) : '-' }}</b-col>
                      <b-col sm="2"><small>Comissão mensal: </small></b-col>
                      <b-col sm="4">{{ data.item.monthlyComissionValue && data.item.monthlyComissionValue > 0 ? $utils.numberFormat(data.item.monthlyComissionValue) : '-' }}</b-col>
                    </b-row>
                    <b-row v-if="data.item.serviceGroupUser">
                      <b-col sm="2"><small>Associado indicado: </small></b-col>
                      <b-col sm="4">{{ data.item.serviceGroupUser.name }}</b-col>
                    </b-row>                    

                </template>

                <template v-slot:cell(costcenter)="data">
                    {{ data.item.costCenterCode  }}<br>{{ data.item.costCenterName }}
                </template>

                <template v-slot:cell(st)="data">
                    <c-switch class="" @change.native="changeStatus(data.item)" color="primary" :checked="data.item.st=='A'" label variant="pill" v-bind="switchLabelIcon" /> 
                </template>
                
                <template v-slot:cell(ispublic)="data">
                    <c-switch class="" color="primary" :checked="data.item.ispublic==1" label variant="pill" v-bind="switchLabelIcon" /> 
                </template>
                
                <template v-slot:cell(action)="data">
                    <!--<b-button size="sm" variant="danger" @click="resync(data.item)" class="mr-1 btn-brand" title="Excluir" style="margin-bottom: 4px">
                    <i class="fa fa-close"></i></b-button>
                    -->
                    <b-button size="sm" variant="primary" @click="openActionModal(data.item)" class="mr-1 btn-brand" title="Atendimento" style="margin-bottom: 4px">                        
                    <i class="fa fa-address-book-o"></i></b-button>
            
                </template>
                
            </b-table>
            <nav>
                <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" prev-text="Anterior" next-text="Próximo" />
            </nav>
  
  
        </b-card-body>
     </b-card>
  
  
     <b-modal
              v-model="editModal"
              id="edit-modal"
              centered
              hide-footer
              title="Indicação"
              size="xl"
              >

        <b-nav fill>
          <b-nav-item :active="tabInfo=='R'" @click="tabInfo='R'">Indicação</b-nav-item>
          <b-nav-item :active="tabInfo=='H'" @click="tabInfo='H'">Histórico</b-nav-item>          
        </b-nav>
        
        <div v-show="tabInfo == 'R'">
          <b-card>
            <referral-component :item="selectedItem" :companyId="filters.companyId" @resp="handleResp"></referral-component>
          </b-card>
        </div>
  
        <div v-show="tabInfo == 'H'">
          <b-card>
            <referral-history-component :item="selectedItem" :companyId="filters.companyId"></referral-history-component>
          </b-card>
        </div>
  
      </b-modal>

      <b-modal
              v-model="actionModal"
              id="action-modal"
              centered
              hide-footer
              title="Atendimento"
              size="lg"
              >
          <referral-action-component :item="selectedItem" :companyId="filters.companyId" @resp="actionHandle"></referral-action-component>
      </b-modal>              
  
    </div>
  
  </template>
  
  <script>
  import Vue from 'vue'
  import axios from "axios"
  import ReferralComponent from './ReferralComponent'
  import ReferralHistoryComponent from './ReferralHistoryComponent'
  import ReferralActionComponent from './ReferralActionComponent'
  
  import { Switch as cSwitch } from '@coreui/vue'
  
  /* Toast */
  import VueNotifications from 'vue-notifications'
  import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr
  //import { table } from 'console'
  
  const toastTypes = {
    success: 'success',
    error: 'error',
    info: 'info',
    warn: 'warn'
  }
  
  miniToastr.init({types: toastTypes})
  
  function toast ({title, message, type, timeout, cb}) {
    return miniToastr[type](message, title, timeout, cb)
  }
  
  const options = {
    success: toast,
    error: toast,
    info: toast,
    warn: toast
  }
  VueNotifications.setPluginOptions(options)
  
  Vue.use(VueNotifications, options)
  /* Toast - End */
  
  const newItem = {id: null, name: '', description: '', st: 'A', _rowVariant: ''}
  
  export default {
    name: 'tables',
    components: {
      Event,
      cSwitch,
      ReferralComponent,
      ReferralHistoryComponent,
      ReferralActionComponent
    },
    data: () => {
      return {
        accessReferralManager: false,
        tabReferral: 'E',
        tabInfo: 'R',
        referralByGroupStatusDDL: [],
        referralStatusDDL: [],
        emptyUserServiceDDL: [
          {
            text: '- Todos -',
            value: 0
          },
          {
            text: 'Associado indicado',
            value: 1
          },
          {
            text: 'Sem associado indicado',
            value: 2
          }
        ],
        statusddl: [
          {
            text: '- Todos -',
            value: 0
          },
          {
            text: 'Ativo',
            value: 'A'
          },
          {
            text: 'Inativo',
            value: 'I'
          }
        ],
        groupDDL: [],
        companyDDL: [],

        isBusy: false,
        currentPage: 1,
        switchLabelIcon: {
            dataOn: '\u2713',
            dataOff: '\u2715'
        },
        switchLabelTxt: {
            dataOn: 'yes',
            dataOff: 'no'
        },
  
        tableRef: "table",
        tableSelectable: false,
        errorMessage: '',
        actionModal: false,
        editModal: false,
        filters: {
          companyId: null,
          groupId: 0,
          key: '',
          status: 0,
          referralStatusId: 'A',
          emptyUserService: 0
        },
  
        modes: ['multi', 'single', 'range'],
        selectMode: 'multi',
        selected: [],
        transProps: {
          // Transition name
          name: 'flip-list'
        },
        primaryKey: "id",
  
        selectedItem: newItem,
        items: [        
        ],
        fields: [
          //{key: 'show_details', label: "", thStyle: { width: "40px" } },
          //{key: 'id' },
          //{key: 'costcenter', label: 'Centro de Custo', sortable: true, thStyle: { width: "200px" }  },
          {key: 'contact', label: 'Indicação', sortable: true, thStyle: { width: "400px" }  },
          //{key: 'serviceDescription', label: 'Descrição do Serviço', sortable: true },
          //{key: 'dueDate', label: 'Data', sortable: true, class: 'text-center', thStyle: { width: "150px" }},
          //{key: 'originalValue', label: 'Valor', sortable: true, class: 'text-right', thStyle: { width: "150px" }},
          //{key: 'paymentValue', label: 'Valor Pago', sortable: true, class: 'text-right', thStyle: { width: "150px" } },
          //{key: 'description', label: 'Descrição', sortable: false },
          //{key: 'serviceTotal', label: 'Serviços', sortable: false, thStyle: { width: "40px" } },
          {key: 'status.name', label: 'Status', sortable: true, class: 'text-center', thStyle: { width: "120px" } },
          {key: 'action', label: '', sortable: true, class: 'text-center', thStyle: { width: "25px" } }
          //{key: 'st', label: 'Status', sortable: true, thStyle: { width: "40px" } }
        ],
        
        filterable: ['username'],
        sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
        perPage: 20
      }
    },
    computed: {
      selectGroupDDL: function() {
          var list = [...this.groupDDL]
          list = list.sort((a,b) => (a.text > b.text) ? 1 : -1)
          list.unshift({ value: '0' , text: '- Todos -' })
          return list
      },
      selectReferralStatusDDL: function() {
          var list = [...this.referralStatusDDL]
          list = list.sort((a,b) => (a.text > b.text) ? 1 : -1)
          list.unshift({ value: '0' , text: '- Todos -' })
          return list
      },
      totalRows: function () { return this.getRowCount() },
      filteredItems() {
        try {

            return this.items.filter(item => {

              if(item.status && item.status.id == 2)
                item._rowVariant = 'danger'
              else
              if(!item.serviceGroupUser || item.serviceGroupUser.id <= 0)
                item._rowVariant = 'warning'

              return (this.filters.key == '' || (
                  this.$utils.filterString(item.serviceDescription, this.filters.key)
                  || (item.id == this.filters.key)
                  //|| this.$utils.filterString(item.serviceGroupUser.name, this.filters.key)
                  //|| this.$utils.filterString(item.groupUser.user.name, this.filters.key)
                  //|| this.$utils.filterString(item.companyName, this.filters.key)
                  //|| this.$utils.filterString(item.contactName, this.filters.key)
                  //|| this.$utils.filterString(item.contactEmail, this.filters.key)

                  //(item.name != null && item.name.toLowerCase().indexOf(this.filters.key.toLowerCase()) > -1)
                  //|| (item.username != null && item.username.toLowerCase().indexOf(this.filters.key.toLowerCase()) > -1)
                  //|| (item.email != null && item.email.toLowerCase().indexOf(this.filters.key.toLowerCase()) > -1)
                  ))
                  && (this.filters.emptyUserService==0 || ( this.filters.emptyUserService == 1 ? item.serviceGroupUserId && item.serviceGroupUserId > 0 : !item.serviceGroupUserId || item.serviceGroupUserId <= 0 ))
                  && (this.filters.status==0 || (this.filters.status == 'A' || this.filters.status == 'I') && item.st == this.filters.status ) 
                  && (this.filters.referralStatusId == 0 || (!isNaN(this.filters.referralStatusId) ? item.statusId == this.filters.referralStatusId : item.status.mainStatusId == this.filters.referralStatusId ))
            })
        }
        catch(e) {
            return this.items;
        }
      }
    },
    methods: {
      handleResp(resp) {
        this.editModal = false
        this.refreshData()
      },
      changeTabReferral(tab) {
        this.tabReferral = tab
        this.refreshData()
      },
      actionHandle(item) {
        this.actionModal = false
        this.refreshData()
      },
      getRowCount: function () {
        if(this.items)
            return this.items.length
        else
            return 0;
      },
     

      changeStatus(item) {
        if(item != null) {
          if(item.st == 'A') 
            item.st = 'I'; 
          else 
            item.st = 'A';
          this.saveItem(item);
        }
      },

      enableDisable() {
        console.log('Habilitando/desabilitando modelo')
        console.log(this.selectedItem);
      },
      closeEditModal() {
        this.editModal = false;
      },
      openEditModal(item) {
        if(item == null) {
            this.selectedItem = { ...newItem };      
        }
        else {
            this.selectedItem = { ...item };
        }
        this.editModal = true;
        this.tabInfo = 'R'
      },
      openActionModal(item) {
        this.selectedItem = item
        this.actionModal = true
      },
      onRowSelected(items) {
        this.selected = items       
      },
      selectAllRows() {
        this.$refs.selectableTable.selectAllRows();
      },
      clearSelectedRows() {
        this.$refs.selectableTable.clearSelected();
      },
      rowClicked(item) {
        if(!this.tableSelectable) {
            this.clearSelectedRows();
            this.openEditModal(item);
        }
      },
      getBadge (status) {
        return status === 'A' ? 'primary'
            : status === 'I' ? 'danger'
            : status === 'Pending' ? 'warning'
                : status === 'Banned' ? 'danger' : 'primary'
      },


      //franchise/referral/status/ddl

      async getReferralStatusByGroup() {
          var s = this;
          var currentUser = this.$store.state.currentUser;
          this.isBusy = true;

          await axios.get(
              this.$store.state.ws_url + "/franchise/referral/status/ddl?group=1&uid=" + currentUser.id + "&sid=" + currentUser.sid
          ).then(function (resp) {
              s.referralByGroupStatusDDL = resp.data.obj;
          }
          ).catch(function (error) {
              console.log(error.message);            
          });

          this.isBusy = false;
    
      },

      async getReferralStatus() {
          var s = this;
          var currentUser = this.$store.state.currentUser;
          this.isBusy = true;

          await axios.get(
              this.$store.state.ws_url + "/franchise/referral/status/ddl?uid=" + currentUser.id + "&sid=" + currentUser.sid
          ).then(function (resp) {
              s.referralStatusDDL = resp.data.obj;
          }
          ).catch(function (error) {
              console.log(error.message);            
          });

          this.isBusy = false;
    
      },

      async getGroup() {
          var s = this;
          var currentUser = this.$store.state.currentUser;
          this.isBusy = true;

          await axios.get(
              this.$store.state.ws_url + "/franchise/group/ddl?companyId=" + s.filters.companyId + "&isGroup=1&uid=" + currentUser.id + "&sid=" + currentUser.sid
          ).then(function (resp) {
              s.groupDDL = resp.data.obj;
          }
          ).catch(function (error) {
              console.log(error.message);            
          });

          this.isBusy = false;
    
      },

     

      async refreshData() {
       
          var s = this;
          var currentUser = this.$store.state.currentUser;
          this.isBusy = true;

          var url;
          if(this.tabReferral == 'S') {
            // Responsável pelo criação da indicação
            url = this.$store.state.ws_url + "/franchise/referral?companyId=" + s.filters.companyId + "&groupId=" + s.filters.groupId + "&referralType=2&uid=" + currentUser.id + "&sid=" + currentUser.sid
          }
          else
          if(this.tabReferral == 'E') {
            // Responsável pelo atendimento da indicação
            url = this.$store.state.ws_url + "/franchise/referral?companyId=" + s.filters.companyId + "&groupId=" + s.filters.groupId + "&referralType=1&uid=" + currentUser.id + "&sid=" + currentUser.sid
          }
          else {
            url = this.$store.state.ws_url + "/franchise/referral?companyId=" + s.filters.companyId + "&groupId=" + s.filters.groupId + "&referralType=0&uid=" + currentUser.id + "&sid=" + currentUser.sid
          }

          await axios.get(
              url
          ).then(function (resp) {
              s.items = resp.data.obj;
          }
          ).catch(function (error) {
              console.log("ERRO")
              console.log(error.message);
              toast ({
                  type: VueNotifications.types.error,
                  title: 'Indicação',
                  message: 'Sem permissão de acesso. Verifique e tente novamente.',
                  timeout: 3000
              })
          });

          this.isBusy = false;
    
      },
      changeCompany() {
        this.getGroup()
        this.refreshData()
      },

      async getAccessReferralManager() {
          var s = this
          var currentUser = this.$store.state.currentUser

          await axios.get(
              this.$store.state.ws_url + "/user/checkaccess?uid=" + currentUser.id + "&sid=" + currentUser.sid + "&accessCode=FRN_REFERRAL_MGR"
          ).then(function(resp) {
            s.accessReferralManager = true
          })
          .catch(function(error) {
            s.accessReferralManager = false
          })
        
      },
      openHelp(url) {
        window.open(this.$store.state.config.ws_help + url, '_blank')
      }
    },
    mounted: function() {
      this.companyDDL = this.$store.state.currentUser.companies
      this.filters.companyId = this.$store.state.currentUser.companyId
    
      this.getAccessReferralManager()
      this.getReferralStatus()
      this.getReferralStatusByGroup()
      this.changeCompany()
    }
  }
  </script>
  
  <style scoped>
  table#table-transition-example .flip-list-move {
  transition: transform 1s;
  }
  </style>